module.exports = __webpack_public_path__ + "img/icon_zwgk.30a135eb.png";